
import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'
import { Action, Getter } from 's-vuex-class'
import { State } from '@/store'
import Dropdown from './Dropdown.vue'
import BaseButton from './BaseButton.vue'
import { getQuestionTypeOptions } from '@/entities'

@Component<FilterBarQuestionType>({
    components: { Dropdown, BaseButton },
})
export default class FilterBarQuestionType extends Vue {
    public npsOnly: boolean = /dash\/crosstab\//.test(window.location.pathname)

    @Getter public filterActive
    @Getter public filterQuestionType

    @Action public setFilterQuestionType

    public get metricOptions() {
        return getQuestionTypeOptions()
    }

    public get selectedOptionLabel(): string {
        const selected = this.metricOptions.find(
            (o) => o.name === this.filterQuestionType
        )
        return selected ? selected.label : 'NPS'
    }

    public setMetricOption(option) {
        this.setFilterQuestionType({
            id: this.filterActive.id,
            question_type: option.name,
        })

        const dropdown = this.$refs.dropdown as Dropdown
        dropdown.$data.opened = false
    }
}
